// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quill {
    flex: 1 1;
    height: 100%;
}

.quill .ql-editor {
    height: 99%;
}

.quill .ql-snow {
    height: 15%;
}

.quill .ql-container {
    height: 85%;
}
`, "",{"version":3,"sources":["webpack://./src/asset/style/utils/quill.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf","sourcesContent":[".quill {\n    flex: 1 1;\n    height: 100%;\n}\n\n.quill .ql-editor {\n    height: 99%;\n}\n\n.quill .ql-snow {\n    height: 15%;\n}\n\n.quill .ql-container {\n    height: 85%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
